module.exports = __webpack_public_path__ + "static/elizabeth-circular-5-9779d21ff938a68bc4fc951b575009f8.png";